import { LegalPage, LegalSection } from "@/pages/legal/LegalPage";
import { COMPANY } from "@/lib/company";

export default function MentionsLegales() {
  return (
    <LegalPage
      testId="page-mentions-legales"
      title="Mentions légales"
      updated="Juillet 2025"
      seoDescription="Mentions légales du site PlanPermis : éditeur, hébergeur et contact."
    >
      <LegalSection title="Éditeur du site">
        <p>
          Le site {COMPANY.brand} est édité par <strong>{COMPANY.legalName}</strong>, société par actions
          simplifiée au capital de {COMPANY.capital}.
          <br />
          Siège social : {COMPANY.address}
          <br />
          {COMPANY.rcs} — SIREN {COMPANY.siren}
          <br />
          N° TVA intracommunautaire : {COMPANY.tva}
          <br />
          Email : {COMPANY.email} — Téléphone : {COMPANY.phone}
        </p>
      </LegalSection>

      <LegalSection title="Directeur de la publication">
        <p>{COMPANY.director}.</p>
      </LegalSection>

      <LegalSection title="Hébergement">
        <p>Le site est hébergé par : {COMPANY.host}.</p>
      </LegalSection>

      <LegalSection title="Nature du service">
        <p>
          {COMPANY.brand} est une plateforme de mise en relation (apporteur d'affaires) entre des élèves et des
          auto-écoles partenaires. {COMPANY.brand} n'est pas une auto-école et ne dispense aucune formation.
        </p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>
          L'ensemble du contenu du site (marque, logo, textes, visuels) est protégé. Toute reproduction non autorisée
          est interdite.
        </p>
      </LegalSection>

      <LegalSection title="Médiation de la consommation">
        <p>
          Conformément aux articles L.612-1 et suivants du Code de la consommation, le consommateur peut recourir
          gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige. Toute demande
          peut être adressée à : {COMPANY.mediatorEmail}.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>Pour toute question : {COMPANY.email}.</p>
      </LegalSection>
    </LegalPage>
  );
}
